import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import type { StrapiRichTextBlock } from '../types';

interface RichTextBlockProps {
  block: StrapiRichTextBlock;
}

export const RichTextBlock = ({ block }: RichTextBlockProps) => {
  return (
    <Box
      sx={{
        '& p': { marginBottom: '16px', lineHeight: 1.7 },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          marginTop: '24px',
          marginBottom: '16px',
          fontWeight: 600,
        },
        '& ul, & ol': { paddingLeft: '24px', marginBottom: '16px' },
        '& li': { marginBottom: '8px' },
        '& code': {
          backgroundColor: 'rgba(0,0,0,0.05)',
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '0.9em',
        },
        '& pre': {
          marginBottom: '16px',
        },
      }}
    >
      <ReactMarkdown
        components={{
          code({ className, children, ...props }: any) {
            const match = /language-(\w+)/.exec(className || '');
            const inline = !match;
            return !inline ? (
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  marginBottom: '16px',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '8px',
                    right: '12px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    color: 'rgba(255,255,255,0.7)',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    zIndex: 1,
                  }}
                >
                  {match[1]}
                </Box>
                <SyntaxHighlighter
                  style={vscDarkPlus as any}
                  language={match[1]}
                  PreTag="div"
                  customStyle={{
                    margin: 0,
                    borderRadius: '16px',
                  }}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              </Box>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
      >
        {block.body}
      </ReactMarkdown>
    </Box>
  );
};
